(() => {
  'use strict';

  const root = document.querySelector('#MainContent[data-template*="raitooe-care-v5"]');
  if (!root) return;

  const dialog = root.querySelector('[data-care-v5-dialog]');
  let returnFocus;

  const openDialog = (trigger) => {
    if (!dialog) return;
    returnFocus = trigger instanceof HTMLElement ? trigger : document.activeElement;
    const topic = dialog.querySelector('[data-care-v5-topic-select]');
    const context = dialog.querySelector('[data-care-v5-context]');
    const message = dialog.querySelector('[name="contact[body]"]');
    const topicValue = trigger?.dataset.careV5Topic;
    const topicOption = topicValue ? Array.from(topic?.options || []).find((option) => option.dataset.careV5TopicOption === topicValue) : null;
    if (topic && topicOption) topic.value = topicOption.value;
    if (context) context.value = trigger?.dataset.careV5Context || '';
    if (message && trigger?.dataset.careV5Message && !message.value) message.value = trigger.dataset.careV5Message;
    dialog.hidden = false;
    document.documentElement.classList.add('care-v5-dialog-open');
    dialog.querySelector('input:not([type="hidden"]),select,textarea,[data-care-v5-close]')?.focus();
  };

  const closeDialog = () => {
    if (!dialog) return;
    dialog.hidden = true;
    document.documentElement.classList.remove('care-v5-dialog-open');
    returnFocus?.focus?.();
  };

  const selectDiagnosis = (button) => {
    const target = button.dataset.careV5Diagnosis;
    if (!target) return;
    root.querySelectorAll('[data-care-v5-diagnosis]').forEach((item) => {
      const active = item.dataset.careV5Diagnosis === target;
      item.classList.toggle('is-active', active);
      if (item.matches('[role="tab"]')) item.setAttribute('aria-selected', String(active));
      else item.setAttribute('aria-pressed', String(active));
    });
    root.querySelectorAll('[data-care-v5-diagnosis-panel]').forEach((panel) => {
      panel.hidden = panel.dataset.careV5DiagnosisPanel !== target;
    });
  };

  const selectRhythm = (button) => {
    const target = button.dataset.careV5Rhythm;
    if (!target) return;
    root.querySelectorAll('[data-care-v5-rhythm]').forEach((item) => item.classList.toggle('is-active', item === button));
    root.querySelectorAll('[data-care-v5-rhythm-panel]').forEach((panel) => {
      panel.hidden = panel.dataset.careV5RhythmPanel !== target;
    });
  };

  root.addEventListener('click', (event) => {
    const target = event.target instanceof Element ? event.target : null;
    if (!target) return;
    const openButton = target.closest('[data-care-v5-open]');
    if (openButton) {
      openDialog(openButton);
      return;
    }
    if (target.closest('[data-care-v5-close]')) {
      closeDialog();
      return;
    }
    const diagnosisButton = target.closest('[data-care-v5-diagnosis]');
    if (diagnosisButton) {
      selectDiagnosis(diagnosisButton);
      return;
    }
    const rhythmButton = target.closest('[data-care-v5-rhythm]');
    if (rhythmButton) selectRhythm(rhythmButton);
  });

  dialog?.addEventListener('click', (event) => {
    if (event.target === dialog) closeDialog();
  });
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && dialog && !dialog.hidden) closeDialog();
  });

  if (dialog?.querySelector('[data-care-v5-auto-open]')) openDialog(null);
})();
